import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "row ourPartnerLogos" };
const _hoisted_2 = {
    key: 0,
    class: "col-12 px-sm-3 pb-45 px-0"
};
const _hoisted_3 = { class: "d-flex fill-height justify-center align-center h-100 align-items-center justify-content-center" };
const _hoisted_4 = ["href", "title"];
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = {
    key: 1,
    class: "col-12 pb-5 pt-4 d-lg-flex d-block flex-wrap justify-content-between align-items-center"
};
const _hoisted_8 = ["href", "title"];
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_carousel_item = _resolveComponent("v-carousel-item");
    const _component_v_carousel = _resolveComponent("v-carousel");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[0] || (_cache[0] = _createElementVNode("p", { class: "h3-responsive mt-4 text-center mb-3" }, "Unsere Partner:", -1)),
                _createVNode(_component_v_card, {
                    elevation: "24",
                    style: { "background-color": "inherit" },
                    class: "mx-auto",
                    flat: ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_carousel, {
                            continuous: true,
                            cycle: true,
                            "show-arrows": false,
                            "hide-delimiters": false,
                            "hide-delimiter-background": "",
                            "delimiter-icon": "icon-circle",
                            height: "140",
                            class: "progressButtonsChanged"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logos, (logo, index) => {
                                    return (_openBlock(), _createBlock(_component_v_carousel_item, { key: index }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_3, [
                                                (logo.link != '')
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        href: logo.link,
                                                        target: "_blank",
                                                        title: logo.title,
                                                        class: "mb-5"
                                                    }, [
                                                        _createElementVNode("img", {
                                                            src: logo.path,
                                                            alt: logo.alt,
                                                            style: { "height": "50px", "width": "100%", "object-fit": "contain" }
                                                        }, null, 8, _hoisted_5)
                                                    ], 8, _hoisted_4))
                                                    : (_openBlock(), _createElementBlock("img", {
                                                        key: 1,
                                                        class: "mb-5",
                                                        src: logo.path,
                                                        alt: logo.alt,
                                                        style: { "height": "50px", "width": "100%", "object-fit": "contain" }
                                                    }, null, 8, _hoisted_6))
                                            ])
                                        ]),
                                        _: 2
                                    }, 1024));
                                }), 128))
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("p", {
                    class: "h4 strong d-md-inline-block d-block mb-0 py-3 fc-gray",
                    style: { "min-width": "180px" }
                }, " Unsere Partner: ", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logos, (logo, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (logo.link)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: logo.link,
                                target: "_blank",
                                title: logo.title
                            }, [
                                _createElementVNode("img", {
                                    class: "m-2",
                                    src: logo.path,
                                    alt: logo.alt,
                                    style: _normalizeStyle([{ "object-fit": "contain" }, logo.extraStyling])
                                }, null, 12, _hoisted_9)
                            ], 8, _hoisted_8))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                class: "m-2",
                                src: logo.path,
                                alt: logo.alt,
                                style: _normalizeStyle([{ "object-fit": "contain" }, logo.extraStyling])
                            }, null, 12, _hoisted_10))
                    ], 64));
                }), 128))
            ]))
    ]));
}
